import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse, HttpHeaders, HttpRequest } from "@angular/common/http";

import { Observable } from 'rxjs/Observable';
import { UserService } from '../user/user.service';

import 'rxjs/add/observable/of';
import 'rxjs/add/operator/do';
import 'rxjs/add/operator/delay';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';

@Injectable()
export class AuthService {

  constructor(
    private http: HttpClient,
    private userService: UserService
  ) {
    this.isLoggedIn = this.userService.loggedIn;
  }

  public isLoggedIn: boolean = false;
  public failedLogin: string = "Please Log In";

  // store the URL so we can redirect after logging in
  redirectUrl: string = '';

  login(user): Observable<any> {
    return this.userService.login(user)
      .map(loginSuccess => {
        this.isLoggedIn = loginSuccess;
      });
  }

  logout(): void {
    this.isLoggedIn = false;
    localStorage.removeItem('currentUser');
  }

  private getBaseUrl(){
    return '/'; // relative URI to enable automatic XSRF by Angular
  }

  private extractData(body:any) {
    if (body){
      return body.data || body;
    } else {
      return {};
    }
  }
}
